import UiModal from '../../../../js/components/UiModal/UiModal'
import { AutoPaymentForm } from '../AutoPaymentForm/scripts'
import { showAlchemerePopup } from '../../../../js/components/Alchemere'

class AutopaymentModalNew extends UiModal {
  constructor(template, { nomenclatureId, methods, type = 'pay' }) {
    super(template, {
      isCenter: true,
      wrapperClass: 'autopayment-modal'
    })

    if (!methods) {
      const error = new Error('[Autopayment modal]: data is required')

      window.Sentry?.captureException(error)
      throw error
    }

    this.methods = methods
    this.type = type
    this.nomenclatureId = nomenclatureId

    this.formInstance = null
    this.formElement = template
  }

  beforeMounted() {
    this.renderForm()
    this.formInstance.form.addEventListener('form-success', this.formSuccessHandler)
  }

  mounted() {
    this.formInstance.setDetailsHeight()
  }

  beforeUnmounted() {
    this.formInstance.form.removeEventListener('form-success', this.formSuccessHandler)
  }

  renderForm() {
    this.formInstance = new AutoPaymentForm(this.contentWrapper, this.formElement, { nomenclatureId: this.nomenclatureId, methods: this.methods })
    this.formInstance.render()
  }

  changeModalForBGroup() {
    const methods = this.element.querySelectorAll('.extended-autopayment-method')
    const cloudpaymentsType = this.element.querySelector('#cloudpayments-type')

    if (!cloudpaymentsType) {
      return
    }

    cloudpaymentsType.querySelector('.extended-autopayment-method__input').checked = true
    cloudpaymentsType.querySelector('.extended-autopayment-method__list').remove()
    cloudpaymentsType.querySelector('.extended-autopayment-method__input').dataset.paymentPrice = 'С дополнительной скидкой'

    if (methods[0] !== cloudpaymentsType) {
      const cloudpayment = Array.from(methods).find(i => i.id === 'cloudpayments-type')

      cloudpaymentsType.remove()
      methods[0].insertAdjacentElement('beforebegin', cloudpayment)

      this.selectPaymentType = this.element.querySelector('.extended-autopayment-method__input:checked')
      this.selectMethod = cloudpayment
    }
  }

  formSuccessHandler = () => {
    this.close()
  }

  beforeClose() {
    showAlchemerePopup('lead')
  }
}

export const showAutopaymentModal = (template, { nomenclatureId, type }) => {
  if (!template) {
    return
  }

  const data = JSON.parse(template.dataset.payments)
  const methods = data?.[nomenclatureId]

  methods && new AutopaymentModalNew(template, { nomenclatureId, methods, type }).init()
}
